import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/select'

import { UserVerifyFilters, UserVerifyRole } from './types'

interface UserVerifyProps {
  search: string
  filters: Partial<UserVerifyFilters>
  onFiltersChange: (
    filters: Partial<UserVerifyFilters | string>,
    isSearch?: boolean,
  ) => void
}

const ROLE_TABS = [
  { label: 'ทั้งหมด', value: undefined },
  { label: 'ผู้ใช้งาน', value: 'USER' },
  { label: 'ร้านค้า', value: 'SHOP' },
  { label: 'แอดมิน', value: 'ADMIN' },
] as const

const IS_VERIFIED_TABS = [
  { label: 'ทั้งหมด', value: undefined },
  { label: 'ยืนยันแล้ว', value: true },
  { label: 'ยังไม่ยืนยัน', value: false },
] as const

export default function UserVerifyFilter({
  search,
  filters,
  onFiltersChange,
}: UserVerifyProps) {
  const handleSearchSubmit = (e: string) => {
    onFiltersChange(e, true)
  }

  // Handler สำหรับเปลี่ยน role
  const handleRoleChange = (role: UserVerifyRole | undefined) => {
    onFiltersChange({
      role,
      page: 1,
    })
  }

  // Handler สำหรับเปลี่ยนสถานะยืนยันโปรไฟล์
  const handleIsVerifiedChange = (isProfileVerified: boolean | undefined) => {
    onFiltersChange({
      isProfileVerified,
      page: 1,
    })
  }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">
              รายการผู้ใช้งาน
            </h2>
          </div>

          <Separator className="border-gray-200" />

          <div className="flex gap-6 flex-wrap">
            {/* ฟิลด์ค้นหา Member Code */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 mb-1">ค้นหา</p>
              <input
                type="text"
                className="input input-bordered text-sm w-full h-9 min-w-[180px] px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="ค้นหาด้วยรหัสสมาชิก.."
                value={search ?? ''}
                onChange={(e) => handleSearchSubmit(e.target.value)}
              />
            </div>

            {/* Role Filter */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 mb-1">บทบาท</p>
              <Select
                value={
                  filters.role === undefined ? 'ALL' : String(filters.role)
                }
                onValueChange={(value) =>
                  handleRoleChange(
                    value === 'ALL' ? undefined : (value as UserVerifyRole),
                  )
                }
              >
                <SelectTrigger className="min-w-[140px]">
                  <SelectValue placeholder="เลือกบทบาท" />
                </SelectTrigger>
                <SelectContent>
                  {ROLE_TABS.map((tab) => (
                    <SelectItem
                      key={tab.value === undefined ? 'ALL' : String(tab.value)}
                      value={
                        tab.value === undefined ? 'ALL' : String(tab.value)
                      }
                    >
                      {tab.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Is Verified Filter */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 mb-1">
                สถานะยืนยันโปรไฟล์
              </p>
              <Select
                value={
                  filters.isProfileVerified === undefined
                    ? 'ALL'
                    : String(filters.isProfileVerified)
                }
                onValueChange={(value) => {
                  if (value === 'ALL') handleIsVerifiedChange(undefined)
                  else handleIsVerifiedChange(value === 'true')
                }}
              >
                <SelectTrigger className="min-w-[140px]">
                  <SelectValue placeholder="เลือกสถานะยืนยันโปรไฟล์" />
                </SelectTrigger>
                <SelectContent>
                  {IS_VERIFIED_TABS.map((tab) => (
                    <SelectItem
                      key={tab.value === undefined ? 'ALL' : String(tab.value)}
                      value={
                        tab.value === undefined ? 'ALL' : String(tab.value)
                      }
                    >
                      {tab.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
